import { TableCell, TableRow } from '@client/toolkit';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import { AgreementActivityLogDto } from '@client/api';

export const TrailRow = ({ item }: { item: AgreementActivityLogDto }) => {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation('type');

  return (
    <>
      <TableRow key={item.id} onClick={() => setExpanded(!expanded)} className="cursor-pointer">
        <TableCell>{format(parseISO(item.logTime), 'dd.MM.yyyy HH:mm')}</TableCell>
        <TableCell>{item.company}</TableCell>
        <TableCell>{item.traceId}</TableCell>
        <TableCell>{item.user}</TableCell>
        <TableCell>{t(`AgreementActivityType.${item.type}`)}</TableCell>
        <TableCell>{t(`AgreementActivitySummary.${item.summary}`)}</TableCell>
        <TableCell>
          {item.changes.length > 0
            ? item.changes.map((change: string, index: number) => <p key={index}>{change}</p>)
            : '-'}
        </TableCell>
        <TableCell>{item.erp || '-'}</TableCell>
        <TableCell>
          <span
            style={{
              color:
                item.result === 'Failure'
                  ? '#f87171'
                  : item.result === 'Success'
                    ? '#4ade80'
                    : item.result === 'InProgress'
                      ? '#facc15'
                      : undefined,
            }}
          >
            {t(`AuditTrailResult.${item.result}`)}
          </span>
        </TableCell>
      </TableRow>
      {expanded && (
        <TableRow>
          <TableCell colSpan={9}>{JSON.stringify(item, null, 2)}</TableCell>
        </TableRow>
      )}
    </>
  );
};
